import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 20L12 5M17 10L12 5L7 10" vectorEffect="non-scaling-stroke" />
	</SVG>
);
